import { render, staticRenderFns } from "./lazyblock_faq.vue?vue&type=template&id=6c3d2106&scoped=true"
import script from "./lazyblock_faq.vue?vue&type=script&lang=js"
export * from "./lazyblock_faq.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_faq.vue?vue&type=style&index=0&id=6c3d2106&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_faq.vue?vue&type=style&index=1&id=6c3d2106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d2106",
  null
  
)

export default component.exports